import { Box, BoxProps, ColorOptions, Icon, Text } from '@jfs/ui-new'
import { FC } from 'react'
import { FlatList } from 'react-native'
import { ModBox } from '../ModifiedBox/ModifiedBox'
import styles from './styles'
import type { ListItemProps } from './types'

const listStrings = {
  selected: 'SELECTED',
  original: 'ORIGINAL',
  testMode: 'Test Mode',
}

const DIVIDER = 'DIVIDER'

const RenderSideMenuSeparator = ({ show, data }: any) => {
  const isTextData = data?.value !== undefined
  if (show) {
    return (
      <Box {...styles.DEFAULT.separator(isTextData)}>
        <ModBox {...styles.DEFAULT.textContainer} show={isTextData}>
          <Text {...styles.DEFAULT.sideMenuSubText}>{data && data?.value}</Text>
        </ModBox>
      </Box>
    )
  } else {
    return null
  }
}

const SubMenuItem = ({ data, handleSubMenuItemPress }) => {
  const isSelected = data?.isSelected
  const onHandlePress = () => {
    handleSubMenuItemPress(data)
  }
  return (
    <Box
      direction="row"
      onPress={onHandlePress}
      underlayColor={'TRANSPARENT'}
      opacity={isSelected ? 1 : 0.8}
      w={'100%'}
      h={'100%'}
      testID="sub-menu-item"
      bg={isSelected ? 'WHITE_SEPERATOR' : undefined}>
      <Box {...styles.SIDE_MENU[isSelected ? 'SELECTED' : 'ORIGINAL'].leftHighlight} />
      <Box pv={12}>
        <Text
          title={`        ${data.value}`}
          color={'WHITE'}
          fontFamily={'jiotype-medium'}
          fontSize={14}
          opacity={isSelected ? 1 : 0.8}
        />
      </Box>
    </Box>
  )
}

export const NavItems: FC<ListItemProps> = ({ data, onPress, onSubMenuItemPress, index }: ListItemProps) => {
  const subType = data?.isSelected ? 'SELECTED' : 'ORIGINAL'
  const hasSubMenu = data?.hasSubMenu ?? false

  const iconId = data?.iconId || ''
  const getHoverStyle = (): BoxProps => {
    let hoverStyle = {}

    return hoverStyle
  }

  const isDataAvailable = () => {
    return data?.filter?.length > 0 ?? false
  }

  const isDivider = data?.isDivider

  const handOnPressOfItem = () => {
    onPress(data)
  }

  const handleSubMenuItemPress = (subItemdata: any) => {
    onSubMenuItemPress(data, subItemdata)
  }

  return (
    <ModBox onPress={handOnPressOfItem} underlayColor={'TRANSPARENT'} testID={`menu-item-${index}`}>
      <>
        <ModBox show={!isDivider}>
          <Box {...styles.SIDE_MENU[subType].container} {...getHoverStyle()}>
            <Box {...styles.SIDE_MENU[subType].leftHighlight} />
            <Icon id={data?.iconId || 'USER'} color={styles.SIDE_MENU.iconColor as ColorOptions} size={16} />

            {isDataAvailable() && (
              <Box {...styles.SIDE_MENU[subType].filterOuterContainer}>
                <Box {...styles.SIDE_MENU[subType].filterContainer}>
                  <Text type={'caption'} fontWeight={'MEDIUM'} color={'PRIMARY_GREY'}>
                    {data?.filter}
                  </Text>
                </Box>
              </Box>
            )}
            <Box {...styles.SIDE_MENU[subType].itemContainer} marginLeft={iconId.length === 0 ? 16 : 0}>
              <Text testID={`menu-item-str-${index}`} {...styles.SIDE_MENU[subType].itemStyle}>
                {data && data?.value}
              </Text>
            </Box>
            <ModBox
              show={data?.showBetaTag ?? false}
              p={1}
              borderWidth={1}
              borderRadius={2}
              marginHorizontal={6}
              borderColor={'BRAND_PRIMARY_ORANGE'}>
              <Text
                color={styles.SIDE_MENU[subType].itemStyle.color}
                title={'BETA'}
                fontFamily="jiotype-bold"
                fontSize={10}
              />
            </ModBox>
            <Box {...styles.SIDE_MENU[subType].separatorStyle} />
            {hasSubMenu && (
              <Box marginLeft={32} underlayColor={'TRANSPARENT'}>
                <Icon
                  id={data?.isSelected ? 'ARROW_UP' : 'ARROW_DOWN'}
                  color={styles.SIDE_MENU.iconColor as ColorOptions}
                  size={14}
                />
              </Box>
            )}
          </Box>
        </ModBox>
      </>
      {hasSubMenu && data?.isSelected && (
        <FlatList
          data={data?.subMenu}
          renderItem={({ item }) => <SubMenuItem data={item} handleSubMenuItemPress={handleSubMenuItemPress} />}
        />
      )}
      <RenderSideMenuSeparator show={isDivider} data={data} />
    </ModBox>
  )
}
